<template>
  <OrderingField
    v-model="context.value.value[props.field.key]"
    :form="props.form"
    :field="props.field"
  />
</template>
<script setup lang="ts">
import { useFormKitContext } from '@formkit/vue'

import OrderingField from '../OrderingField.vue'
import type { SchemaFormKitProps } from './types'

const props = defineProps<SchemaFormKitProps>()
const context = useFormKitContext()
</script>
